export default __webpack_public_path__ + "static/media/nbc.20fd81b8.svg";